import { useState } from 'react';

function americanToDecimal(american) {
	const a = parseFloat(american);
	if (isNaN(a) || a === 0) return NaN;
	if (a > -100 && a < 100) return NaN;
	if (a > 0) return a / 100 + 1;
	return 100 / Math.abs(a) + 1;
}

export const ArbitrageCalculator = () => {
	const [oddsA, setOddsA] = useState('');
	const [oddsB, setOddsB] = useState('');
	const [totalStake, setTotalStake] = useState('');

	const decA = americanToDecimal(oddsA);
	const decB = americanToDecimal(oddsB);
	const stakeNum = parseFloat(totalStake);

	const hasResults = !isNaN(decA) && decA > 1 && !isNaN(decB) && decB > 1;

	let results = null;
	if (hasResults) {
		const impliedA = 1 / decA;
		const impliedB = 1 / decB;
		const arbPct = ((impliedA + impliedB) - 1) * 100;
		const isArb = arbPct < 0;

		let stakeA = null, stakeB = null, profit = null, roi = null;
		if (!isNaN(stakeNum) && stakeNum > 0) {
			stakeA = (stakeNum * impliedA) / (impliedA + impliedB);
			stakeB = stakeNum - stakeA;
			const payoutA = stakeA * decA;
			const payoutB = stakeB * decB;
			profit = Math.min(payoutA, payoutB) - stakeNum;
			roi = (profit / stakeNum) * 100;
		}

		results = {
			impliedA: impliedA * 100,
			impliedB: impliedB * 100,
			arbPct,
			isArb,
			stakeA,
			stakeB,
			profit,
			roi,
		};
	}

	const handleReset = () => {
		setOddsA('');
		setOddsB('');
		setTotalStake('');
	};

	return (
		<div>
			<div className="calc-section">
				<h3 className="calc-section-title">Market Odds (American)</h3>
				<div className="calc-grid calc-grid-2">
					<div className="calc-input-group">
						<label className="calc-label">Outcome A Odds (Book 1)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="+150"
							value={oddsA}
							onChange={(e) => setOddsA(e.target.value)}
						/>
					</div>
					<div className="calc-input-group">
						<label className="calc-label">Outcome B Odds (Book 2)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="+120"
							value={oddsB}
							onChange={(e) => setOddsB(e.target.value)}
						/>
					</div>
				</div>
			</div>

			<div className="calc-section">
				<div className="calc-input-group" style={{ maxWidth: '200px' }}>
					<label className="calc-label">Total Stake ($)</label>
					<input
						className="calc-input"
						type="text"
						placeholder="1000"
						value={totalStake}
						onChange={(e) => setTotalStake(e.target.value)}
					/>
				</div>
			</div>

			{results && (
				<div className="calc-results">
					<h4 className="calc-results-title">Arbitrage Results</h4>
					<div style={{ marginBottom: '1rem' }}>
						<span className={`calc-arb-indicator ${results.isArb ? 'yes' : 'no'}`}>
							{results.isArb ? '✓ Arbitrage Found!' : '✗ No Arbitrage'}
						</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Implied Prob A</span>
						<span className="calc-result-value">{results.impliedA.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Implied Prob B</span>
						<span className="calc-result-value">{results.impliedB.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Combined Margin</span>
						<span className={`calc-result-value ${results.isArb ? 'positive' : 'negative'}`}>
							{results.arbPct.toFixed(2)}%
						</span>
					</div>
					{results.stakeA !== null && (
						<>
							<div className="calc-result-row">
								<span className="calc-result-label">Stake on A</span>
								<span className="calc-result-value">${results.stakeA.toFixed(2)}</span>
							</div>
							<div className="calc-result-row">
								<span className="calc-result-label">Stake on B</span>
								<span className="calc-result-value">${results.stakeB.toFixed(2)}</span>
							</div>
							<div className="calc-result-row">
								<span className="calc-result-label">Guaranteed Profit</span>
								<span className={`calc-result-value ${results.profit >= 0 ? 'positive' : 'negative'}`}>
									{results.profit >= 0 ? '+' : ''}${results.profit.toFixed(2)}
								</span>
							</div>
							<div className="calc-result-row">
								<span className="calc-result-label">ROI</span>
								<span className={`calc-result-value ${results.roi >= 0 ? 'positive' : 'negative'}`}>
									{results.roi >= 0 ? '+' : ''}{results.roi.toFixed(2)}%
								</span>
							</div>
						</>
					)}
				</div>
			)}

			<button className="calc-reset-btn" onClick={handleReset}>Reset</button>
		</div>
	);
};
